module.exports = __webpack_public_path__ + "img/logo-loto-vert-hotpicks.1e48541f.jpg";